import React from 'react';
import {
  Clock, Users, FileSearch, Flame,
} from 'lucide-react';

const burdens = [
  {
    icon: Clock,
    title: 'Manual Window Tracking',
    description: 'Option deadlines tracked in spreadsheets and calendar reminders.',
  },
  {
    icon: Users,
    title: 'Cross-Team Confusion',
    description: 'Leasing, property management, and asset teams rely on different sources of truth.',
  },
  {
    icon: FileSearch,
    title: 'PDF Hunting',
    description: 'Key terms buried across base leases and amendments.',
  },
  {
    icon: Flame,
    title: 'Last-Minute Fire Drills',
    description: 'Deadlines surface only when space becomes available.',
  },
];

export function OperationalSection(): JSX.Element {
  return (
    <section className='bg-muted/40 py-24 md:py-32'>
      <div className='mx-auto max-w-6xl px-6'>
        <div className='mx-auto max-w-2xl text-center'>
          <h2
            className='text-3xl font-bold tracking-tight text-foreground md:text-4xl text-balance'
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            {'Operational Chaos Doesn\u2019t Scale.'}
          </h2>

          <p className='mt-6 text-base leading-relaxed text-muted-foreground'>
            Managing lease rights manually creates daily friction across teams.
          </p>
        </div>

        <div className='mt-16 grid gap-8 md:grid-cols-2 lg:grid-cols-4'>
          {burdens.map((burden) => (
            <div
              key={burden.title}
              className='group rounded-2xl border border-border bg-card p-8 transition-all hover:shadow-lg hover:border-teal/40'
            >
              <div className='flex h-12 w-12 items-center justify-center rounded-xl bg-teal/20'>
                <burden.icon className='h-6 w-6 text-foreground' />
              </div>
              <h3 className='mt-6 text-lg font-semibold text-foreground' style={{ fontFamily: 'var(--font-heading)' }}>
                {burden.title}
              </h3>
              <p className='mt-3 text-sm leading-relaxed text-muted-foreground'>
                {burden.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
